import { YupSchema } from 'services/yup/types'
import { packageBaseVS } from './packageBase'
import {
  EventPackage,
  EventPackagePackageKeys,
  EventPackagePackages,
} from 'services/api/entities/catalog/packages/eventPackage'
import { tailoredProductVS } from '../tailoredProduct'
import { yupArray, yupNumber, yupObject } from 'services/yup'
import * as yup from 'yup'
import { optionedPackageVS } from './optionedPackage'
import { foodPackageVS } from './foodPackage'
import { locationPackageVS } from './locationPackage'
import { drinkPackageVS } from './drinkPackage'
import { baseProductPackageVS } from './baseProductPackage'
import {
  BaseProductPackage,
  OptionedPackage,
  PackageBase,
} from 'services/api/entities/catalog/packages/common'
import { DrinkPackage } from 'services/api/entities/catalog/packages/drinkPackage'
import { LocationPackage } from 'services/api/entities/catalog/packages/locationPackage'
import { FoodPackage } from 'services/api/entities/catalog/packages/foodPackage'
import { PossiblyEmptyString, ValueOf } from '../../../../types/common'

// Here we are building our schema validation with the lazy mode
// this allows us to to get the schema on runtime depending on the type of the field
const getProductPackageVS =
  <TPackage extends PackageBase>(validationSchema: YupSchema<TPackage>) =>
  (value: number | '' | BaseProductPackage) =>
    typeof value === 'number' || value === ''
      ? yupNumber()
          .transform((v: number) => (isNaN(v) ? undefined : v))
          .optional()
      : validationSchema

export const eventPackageVS: YupSchema<
  EventPackage,
  ValueOf<PossiblyEmptyString<EventPackagePackages, EventPackagePackageKeys>>
> = packageBaseVS.concat(tailoredProductVS).shape({
  image: yupObject().required(),
  sections: yupArray(),
  rentPackage: yup.lazy(
    getProductPackageVS<BaseProductPackage>(baseProductPackageVS)
  ),
  physicalPackage: yup.lazy(
    getProductPackageVS<OptionedPackage>(optionedPackageVS)
  ),
  foodPackage: yup.lazy(getProductPackageVS<FoodPackage>(foodPackageVS)),
  locationPackage: yup.lazy(
    getProductPackageVS<LocationPackage>(locationPackageVS)
  ),
  drinkPackage: yup.lazy(getProductPackageVS<DrinkPackage>(drinkPackageVS)),
  professionalPackage: yup.lazy(
    getProductPackageVS<BaseProductPackage>(baseProductPackageVS)
  ),
  musicPackage: yup.lazy(
    getProductPackageVS<BaseProductPackage>(baseProductPackageVS)
  ),
})
